// 用户功能权限 key
export const Feature_Key = {
  // 家装公司信息展示
  marketingsCompanyInfo: 'MarketingsCompanyInfo',
  // 获取客户信息(获取方案）
  marketingsCustomerInfoXCX: 'MarketingsCustomerInfoXCX',
  // 电视广告
  televisionAD: 'TelevisionAD',
  // 背景音乐
  backgroundMusic: 'BackgroundMusic',
  // 演示模式
  demoMode: 'DemoMode',
  // 分屏对比
  decoSplitScreenDiff: 'DecoSplitScreenDiff',
  // 报价
  spaceDesignQuote: 'SpaceDesignQuote',
  /** 生成海报 */
  exportPoster: 'ExportPoster',
  /** 分享视频 */
  exportDecoVideo: 'ExportDecoVideo',
  /** 下载户型图 */
  downloadFloorPlan: 'DownloadFloorPlan',
  /** 下载图片 */
  exportDecoScreenshot: 'ExportDecoScreenshot',
  /** 设计师模式 */
  designerFeature: 'DesignerFeature'
};

export const getUserFeatureByUserId = async (userGUID) => {
  const classifyKey = 'Player,Studio';
  const featureKey = Object.values(Feature_Key).join(',');
  const {state, payload} = await HouseViewer.DIY2DInterface.getUserFeatureByUserId({userGUID, classifyKey, featureKey});
  if (state === 200) return payload;
};

// 通过 provide 注入的，已开通的用户权限数组数据的 key，可以用 inject 接受
export const Charged_Feature_Array = 'chargedFeatureArray';
